import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSetState } from '@campaignhub/react-hooks'
import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

import { Box, Text } from '@campaignhub/suit-theme'

import useFilter from '@hooks/useFilter'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown, faAngleUp, faEye, faPlus,
} from '@fortawesome/pro-light-svg-icons'

import View from './components/View'

const defaultState = {
  customViewState: [],
  expanded: true,
  selectedCustomView: null,
}

const ViewFilter = (props) => {
  const { setJobState, jobState } = props
  const { customFilter } = jobState

  const entities = useSelector(reduxState => reduxState.entities)
  const { filters } = entities

  const filtersOptions = {
    entityType: 'serviceJob',
    ...customFilter?.length && { customFilters: customFilter.join(',') },
  }

  useReduxAction('filters', 'loadFilters', filtersOptions, [customFilter])

  const [state, setState] = useSetState(defaultState)
  const { customViewState, expanded, selectedCustomView } = state

  const initFilter = { id: null }
  const { callbacks: { launchCreateServiceJobViewModal } } = useFilter(initFilter)

  useEffect(() => {
    setState({
      customViewState: Object.values(filters).map(filter => ({
        ...filter,
        isChecked: selectedCustomView === filter.id,
      })),
    })
  }, [filters, selectedCustomView])

  const updateCustomView = (checked, view) => {
    if (checked){
      setJobState({
        accountManagerFilter: view.accountManagers,
        classificationFilter: view.classifications,
        clientFilter: view.clients,
        customFilter: view.customFilters,
        filterTags: view.tags,
        jobTypeFilter: 'all',
        serviceDateFilter: {
          filterStart: view?.serviceDateStart || '',
          filterEnd: view?.serviceDateEnd || '',
        },
        serviceFilter: view.services,
        serviceUserFilter: view.serviceUsers,
        statusFilter: view.serviceJobStatuses,
        userFilter: view.users,
      })
    } else {
      setJobState({
        accountManagerFilter: [],
        classificationFilter: [],
        clientFilter: [],
        customFilter: [],
        filterTags: [],
        jobTypeFilter: 'all',
        serviceDateFilter: {
          filterStart: '',
          filterEnd: '',
        },
        serviceFilter: [],
        serviceUserFilter: [],
        statusFilter: [],
        userFilter: [],
      })
    }

    setState({ selectedCustomView: checked ? view.id : null })
  }

  return (
    <Box flexDirection="column">
      <Box
        flexDirection="row"
        style={{ cursor: 'pointer' }}
        lineHeight="1.5"
        marginBottom={expanded && customViewState.length ? 'medium' : null}
        onClick={() => setState({ expanded: !expanded })}
      >
        <Box
          color="bodyFontLightColor"
          marginLeft="auto"
          width="auto"
          marginRight="medium"
        >
          <FontAwesomeIcon icon={faEye} />
        </Box>
        <Box flexDirection="column">
          <Text
            color="bodyFontLightColor"
            fontSize="small"
            fontWeight="medium"
            fontAlign="center"
          >
            Views
          </Text>
        </Box>
        <Box
          color="bodyFontLightColor"
          marginLeft="medium"
          width="auto"
          onClick={(e) => {
            e.stopPropagation()
            launchCreateServiceJobViewModal()
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Box>
        <Box
          color="bodyFontLightColor"
          marginLeft="medium"
          width="auto"
          marginRight="auto"
        >
          <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />
        </Box>
      </Box>
      {expanded && (
        <Box flexDirection="column" alignItems="center" lineHeight="1.5">
          {customViewState.map(view => <View key={view.id} view={view} updateCustomView={updateCustomView} />)}
        </Box>
      )}
    </Box>
  )
}

ViewFilter.propTypes = {
  setJobState: PropTypes.func,
  jobState: PropTypes.object,
}

export default ViewFilter
